import { render, staticRenderFns } from "./search-filters.vue?vue&type=template&id=c2ae7a0e&scoped=true"
import script from "./search-filters.vue?vue&type=script&lang=js"
export * from "./search-filters.vue?vue&type=script&lang=js"
import style0 from "./search-filters.vue?vue&type=style&index=0&id=c2ae7a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae7a0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VSelect: require('/var/www/tubber-new/components/global/v/select.vue').default})
